import React from 'react';
import styled from 'styled-components';

import { staffImportTokens } from '../styles/staffImportTokens';

const OrDividerRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${staffImportTokens.spacing.sectionGap}px;
    width: 100%;
`;

const OrLine = styled.div`
    flex: 1;
    height: 1px;
    background: ${staffImportTokens.colors.grey5};
`;

const OrLabel = styled.span`
    font-family: 'Montserrat', sans-serif;
    font-size: ${staffImportTokens.typography.label.fontSize};
    font-weight: ${staffImportTokens.typography.label.fontWeight};
    line-height: ${staffImportTokens.typography.label.lineHeight};
    color: ${staffImportTokens.colors.textPrimary};
    white-space: nowrap;
`;

export const StaffImportOrDivider: React.FC = () => (
    <OrDividerRow aria-hidden="true">
        <OrLine />
        <OrLabel>OR</OrLabel>
        <OrLine />
    </OrDividerRow>
);

export default StaffImportOrDivider;
